import React from 'react';
import PropTypes from 'prop-types';

import ConfirmationModal from './index';
import 'assets/scss/confirmation-modal.css';
import check_icon from 'assets/img/confirmation_modal_check_icon.svg';

const ConfirmationEmailDashboard = ({
  isVisible,
  toggleModal,
  toggleEmailUpdate,
  resendConfirmation,
}) => {
  return (
    <ConfirmationModal isVisible={isVisible} toggleModal={toggleModal}>
      <img className="mb-5" src={check_icon} />
      <h2>Your email needs to be verified.</h2>
      <p>
        To continue to enjoy all of the benefits of Soono, please verify your
        email address.
      </p>
      <button
        className="btn btn-warning btn-sm py-3 px-md-4 px-3 text-white text-bold border-0 mb-2"
        onClick={e => {
          e.preventDefault();
          resendConfirmation();
        }}
      >
        RESEND CONFIRMATION EMAIL
      </button>
      <p>
        <span className="cursor-pointer" onClick={toggleEmailUpdate}>
          Change your existing email here
        </span>
      </p>
    </ConfirmationModal>
  );
};

ConfirmationEmailDashboard.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
};

export default ConfirmationEmailDashboard;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/Modal/ConfirmationEmailDashboard.js